import { createFileRoute } from "@tanstack/react-router";
import PartsCatalogOrderView from "@/pages/PartsCatalogOrderView";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/order/$orderNumber")({
  head: () => { const h = pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/parts-catalog/order/:orderNumber' }); h.meta.push({ name: "robots", content: "noindex, follow" }); return h; },
  component: PartsCatalogOrderView,
});
